export const POLYDATA_FIELDS = ['verts', 'lines', 'polys', 'strips'];

export default {
  POLYDATA_FIELDS,
};
